import EventBus from "@plugins/common/service/eventbus";

const textToSpeechEventBus = new EventBus();
export default textToSpeechEventBus;
